<template>
  <v-container fluid>
    <v-tabs v-if="lmenu && lmenu.user_type_id !== '35fcfdaf' && lmenu.user_type !== 'Guest'"
            v-model="active"
            slider-color="#587e27"
            class="futuristic-tabs">
      <v-tab key="tab-1" ripple class="earth futuristic-tab">Calendar</v-tab>
      <v-tab key="tab-2" ripple class="earth futuristic-tab">Checking In Today</v-tab>
      <v-tab v-if="lmenu.user_type !== 'Guest'" key="tab-3" ripple class="earth futuristic-tab">Checking Out Today</v-tab>
      <v-tab v-if="lmenu.user_type !== 'Guest'" key="tab-4" ripple class="earth futuristic-tab">Overstays</v-tab>
      <v-tab key="tab-5" ripple class="earth futuristic-tab">
        UNTICKETED ALERTS
        <div class="d-flex justify-end mb-6">
          <v-btn v-if="lmenu.user_type !== 'Gate Keeper'" depressed
                 small
                 color="#587e27"
                 @click="openGateEntryDialog"
                 class="futuristic-btn action-btn white--text">
            Add Gate Entry
          </v-btn>
        </div>
      </v-tab>

      <v-tab-item key="tab-1">
        <v-card flat class="futuristic-card">
          <calendar style="margin-top: 2%"></calendar>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-2">
        <v-card flat class="futuristic-card">
          <check-in-today></check-in-today>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-3">
        <v-card flat class="futuristic-card">
          <check-out-today></check-out-today>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-4">
        <v-card flat class="futuristic-card">
          <overstays></overstays>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-5">
        <v-card flat class="futuristic-card">
          <BookingUnticketed />
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!-- Guest-specific tabs - FULLY CORRECTED -->
<v-tabs v-if="lmenu && lmenu.user_type === 'Guest'"
        v-model="activeGuest"
        slider-color="#587e27"
        class="futuristic-tabs">
  <v-tab key="guest-experiences-tab" ripple class="earth futuristic-tab">Experiences</v-tab>
  <v-tab key="guest-summary-tab" ripple class="earth futuristic-tab">Summary</v-tab>
  
  <v-tab-item key="guest-experiences-tab">
    <v-card flat class="futuristic-card">
      <guest-experiences></guest-experiences>
    </v-card>
  </v-tab-item>
  
  <v-tab-item key="guest-summary-tab">
    <v-card flat class="futuristic-card">
      <guest-summary></guest-summary>
    </v-card>
  </v-tab-item>
</v-tabs>

    <v-tabs v-if="lmenu && lmenu.user_type_id === '35fcfdaf'"
            v-model="active"
            slider-color="#587e27"
            class="futuristic-tabs">
      <v-tab key="tab-5" ripple class="earth futuristic-tab">Dashboard</v-tab>
      <v-tab key="tab-6" ripple class="earth futuristic-tab">Conservation Fees and Vehicles</v-tab>
      <v-tab key="tab-7" ripple class="earth futuristic-tab">Checking In Today</v-tab>
      <v-tab key="tab-8" ripple class="earth futuristic-tab">Checking Out Today</v-tab>
      
      <v-tab-item key="tab-5">
        <v-card flat class="futuristic-card">
          <partner-dashboard></partner-dashboard>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-6">
        <v-card flat class="futuristic-card">
          <partner-conservation-dashboard></partner-conservation-dashboard>
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-7">
        <v-card flat class="futuristic-card">
          <partner-check-in-today />
        </v-card>
      </v-tab-item>
      <v-tab-item key="tab-8">
        <v-card flat class="futuristic-card">
          <partner-check-out-today />
        </v-card>
      </v-tab-item>
    </v-tabs>

    <v-card v-if="lmenu && lmenu.user_type === 'Partners'" class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color futuristic-title">Bookings</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                      v-model="search"
                      class="futuristic-search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="columns"
                    :items="partnerBookings"
                    :search="search"
                    :loading="$loadingTrue"
                    class="futuristic-table">
        <v-progress-linear slot="progress" color="#587e27" indeterminate class="futuristic-progress"></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="futuristic-cell">{{ props.item.booking_ref_code }}</td>
          <td class="futuristic-cell">{{ props.item.booking_done_by }}</td>
          <td class="futuristic-cell">{{ props.item.booking_type }}</td>
          <td class="futuristic-cell">{{ formated_date(props.item.booking_check_in_date) }}</td>
          <td class="futuristic-cell">{{ formated_date(props.item.booking_check_out_date) }}</td>
          <td class="futuristic-cell">{{ props.item.guest_total }}</td>
          <td class="futuristic-cell"
              :class="props.item.booking_status === 'Confirmed' ? 'action-taken-yes' : 'action-taken-no'"
              v-bind:style="props.item.booking_color">
            {{ props.item.booking_status }}
          </td>
          <td class="futuristic-cell">
            <v-btn :depressed="true"
                   small
                   color="#f1c40f"
                   @click="openBooking(props.item.booking_public_id)"
                   class="futuristic-btn action-btn white--text">
              View Booking
            </v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>

    <!-- Gate Entry Dialog -->
    <v-dialog v-model="unticketed_alert_dialog" persistent max-width="600px">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          <h4 class="earth-color dialog-title">GATE ENTRY DETAILS</h4>
        </v-card-title>
        
        <v-card-text class="dialog-content">
          <!-- Switch moved to top as in second version -->
          <v-switch
            v-model="isConservancyVehicle"
            label="Conservancy Vehicle"
            color="green"
            class="conservancy-switch"
            readonly
          >
            <template v-slot:label>
              <span class="switch-label">Conservancy Vehicle</span>
            </template>
          </v-switch>
          
          <!-- Show note based on selection (from first version) -->
          <div v-if="isConservancyVehicle" class="vehicle-note mb-4">
            <v-alert type="info" dense outlined class="info-alert">
              <small>Select from registered conservancy vehicles and provide driver/mileage details</small>
            </v-alert>
          </div>
          <div v-else class="vehicle-note mb-4">
            <v-alert type="warning" dense outlined class="warning-alert">
              <small>Enter external vehicle registration number</small>
            </v-alert>
          </div>
          
          <v-container class="form-container">
            <!-- Entrance and Destination in a row (merged from both) -->
            <div class="row-inputs">
              <v-select
                label="Select Entrance"
                v-model="unticketed_details.unticketed_gate"
                :items="allGates"
                item-text="gate_name"
                item-value="gate_public_id"
                :rules="[(v) => !!v || 'Entrance is required']"
                required
                outlined
                dense
                class="row-field"
              />

              <v-autocomplete
                label="Destination*"
                v-model="unticketed_details.unticketed_destination"
                :items="allDestinations"
                item-text="destination_name"
                item-value="destination_public_id"
                :loading="$loadingTrue"
                :rules="[(v) => !!v || 'Destination is required']"
                required
                outlined
                dense
                class="row-field"
              ></v-autocomplete>
            </div>

            <!-- Name field (from first version) -->
            <v-text-field
              label="Name*"
              v-model="unticketed_details.unticketed_name"
              :rules="[(v) => !!v || 'Name is required']"
              required
              outlined
              dense
              class="form-field"
            />

            <!-- Vehicle Type dropdown (from first version) -->
            <v-select
              label="Vehicle Type*"
              v-model="unticketed_details.unticketed_vehicle_type"
              :items="vehicleTypes"
              item-text="vehicle_charge_category"
              item-value="vehicle_charge_public_id"
              :rules="[(v) => !!v || 'Vehicle type is required']"
              required
              outlined
              dense
              class="form-field"
            />

            <!-- People counts (merged from both) -->
            <div class="number-inputs">
              <v-text-field
                label="Number of Adults"
                type="number"
                min="0"
                step="1"
                v-model="unticketed_details.unticketed_adults"
                :placeholder="'0'"
                :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                required
                outlined
                dense
                class="number-field"
                @keydown="event => { if (event.key === '-') event.preventDefault() }"
              ></v-text-field>

              <v-text-field
                label="Number of Children"
                type="number"
                min="0"
                step="1"
                v-model="unticketed_details.unticketed_children"
                :placeholder="'0'"
                :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                required
                outlined
                dense
                class="number-field"
                @keydown="event => { if (event.key === '-') event.preventDefault() }"
              ></v-text-field>
            </div>

            <div class="number-inputs">
              <v-text-field
                label="Number of Infants"
                type="number"
                min="0"
                step="1"
                v-model="unticketed_details.unticketed_infants"
                :placeholder="'0'"
                :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                required
                outlined
                dense
                class="number-field"
                @keydown="event => { if (event.key === '-') event.preventDefault() }"
              ></v-text-field>

              <v-text-field
                label="Number of Tour driver/guide"
                type="number"
                min="0"
                step="1"
                v-model="unticketed_details.unticketed_guide"
                :placeholder="'0'"
                :rules="[(v) => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater']"
                required
                outlined
                dense
                class="number-field"
                @keydown="event => { if (event.key === '-') event.preventDefault() }"
              ></v-text-field>
            </div>

            <!-- Vehicle Section (merged from both) -->
            <div class="vehicle-section">
              <v-autocomplete
                v-if="isConservancyVehicle"
                label="Select Vehicle Registration*"
                v-model="unticketed_details.unticketed_vehicle_registration"
                :items="allAutos"
                :item-text="item => item.auto"
                item-value="auto"
                :loading="isLoadingVehicles"
                :rules="[(v) => !!v || 'Select a conservancy vehicle']"
                required
                outlined
                dense
                prepend-inner-icon="mdi-car"
                class="form-field"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.auto }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.vehicle_type">
                      {{ item.vehicle_type }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              
              <v-text-field
                v-else
                label="Enter Vehicle Registration*"
                v-model="unticketed_details.unticketed_vehicle_registration"
                :rules="[(v) => !!v || 'Vehicle registration is required']"
                required
                outlined
                dense
                prepend-inner-icon="mdi-car"
                class="form-field"
              />
            </div>

            <!-- Driver and Mileage Section (merged from both) -->
            <div v-if="isConservancyVehicle && unticketed_details.unticketed_vehicle_registration" class="driver-section">
              <v-autocomplete
                label="Select Driver*"
                v-model="unticketed_details.unticketed_driver"
                :items="allDrivers"
                :item-text="item => item.driver"
                item-value="driver"
                :loading="isLoadingDrivers"
                :rules="[(v) => !!v || 'Select a driver']"
                required
                outlined
                dense
                prepend-inner-icon="mdi-account"
                class="row-field"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.driver }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.phone && item.phone.trim()">
                      {{ item.phone }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              
              <v-text-field
                label="Enter Mileage*"
                v-model="unticketed_details.unticketed_mileage"
                type="number"
                step="0.1"
                min="0"
                :rules="[
                  (v) => !!v || 'Mileage is required',
                  (v) => parseFloat(v) >= 0 || 'Mileage must be positive',
                  (v) => !isNaN(parseFloat(v)) || 'Enter a valid number'
                ]"
                required
                outlined
                dense
                prepend-inner-icon="mdi-speedometer"
                class="form-field"
              />
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="unticketed_alert_dialog = false"
            class="action-btn"
          >
            Close
          </v-btn>
          <v-btn   
            v-if="unticketed_details.unticketed_destination && (unticketed_details.unticketed_adults > 0 || unticketed_details.unticketed_guide > 0) && unticketed_details.unticketed_vehicle_registration"
            color="green" 
            @click="postAlert()" 
            class="action-btn submit-btn white--text"
          >
            Add Gate Entry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Calendar from './Calendar.vue';
  import CheckInToday from './Bookings/CheckInToday';
  import CheckOutToday from './Bookings/CheckOutToday';
  import Overstays from './Bookings/Overstays';
  import BookingUnticketed from './Bookings/BookingUnticketed.vue';
  import PendingPartnerBookings from './Bookings/PendingPartnerBookings';
  import PendingSchoolBooking from './Bookings/PendingSchoolBooking';
  import ApprovedBookings from './Bookings/ApprovedBookings';
  import PartnerCheckInToday from './Bookings/PartnerCheckInToday';
  import PartnerCheckOutToday from './Bookings/PartnerCheckOutToday';
  import ConservationVehicleCalendar from './ConservationVehicleCalendar';
  import PartnerDashboard from './Bookings/PartnerDashboard';
  import PartnerConservationDashboard from './Bookings/PartnerConservationDashbaord';
  import GuestExperiences from './Bookings/GuestExperiences.vue'
  import GuestSummary from './Bookings/MyBookingsHistory.vue'
  import BookingUnticketedAlert from './Bookings/BookingUnticketedAlert.vue'

  export default {
    components: {
      ConservationVehicleCalendar,
      PartnerCheckOutToday,
      PartnerCheckInToday,
      ApprovedBookings,
      PendingSchoolBooking,
      PendingPartnerBookings,
      CheckOutToday,
      Overstays,
      BookingUnticketed,
      BookingUnticketedAlert,
      CheckInToday,
      Calendar,
      PartnerDashboard,
      GuestExperiences,
      GuestSummary,
      PartnerConservationDashboard,
    },
    data() {
      let lmenuData = null;
      try {
        lmenuData = JSON.parse(localStorage.getItem('unem') || '{}');
      } catch (e) {
        lmenuData = {};
      }

      return {
        active: lmenuData.user_type_id === '589c3b1b' || lmenuData.user_type_id === '6bd0cb4a' ? 4 : 0,
        activeGuest: 0, // Added for Guest tabs
        user_type: localStorage.getItem('mnbvcxz'),
        lmenu: lmenuData,
        search: '',
        gateEntryDialog: false,
        gateEntryNote: {
          booking_id: 'new',
          note: '',
          show_on_invoice: false,
          ranger_note: 1,
          alert: false,
        },
        isConservancyVehicle: false,
        vehicleTypes: [],
        unticketed_alert_dialog: false,
        unticketed_details: this.getDefaultUnticketedDetails(),
        isLoadingVehicles: false,
        isLoadingDrivers: false,
        columns: [
          { text: 'Booking Ref', value: 'booking_ref_code' },
          { text: 'Booked By', value: 'booking_done_by' },
          { text: 'Type', value: 'booking_type' },
          { text: 'Check In', value: 'booking_check_in_date' },
          { text: 'Check Out', value: 'booking_check_out_date' },
          { text: 'Guests', value: 'guest_total' },
          { text: 'Status', value: 'booking_status' },
          { text: 'Action', value: 'action' },
        ],
        allVehiclesFees: [],
      };
    },
    computed: {
      partnerBookings() {
        return this.$store.state.BookingStore.partner_bookings || [];
      },
      allDestinations() {
        return this.$store.state.DestinationStore.all_destinations || [];
      },
      allGates() {
        return this.$store.state.GateStore.all_gates || [];
      },
      allAutos() {
        return this.$store.state.AutoStore.all_autos || [];
      },
      allDrivers() {
        return this.$store.state.DriverStore.all_drivers || [];
      },
    },
    methods: {
      getDefaultUnticketedDetails() {
        return {
          unticketed_gate: '05e7ee16',
          unticketed_destination: '',
          unticketed_name: '',
          unticketed_vehicle_type: '',
          unticketed_adults: 0,
          unticketed_children: 0,
          unticketed_infants: 0,
          unticketed_guide: 0,
          unticketed_alert: '',
          unticketed_vehicle_registration: '',
          unticketed_driver: '',
          unticketed_mileage: '',
          convert_to_booking: false,
          alert: true,
          session_id: localStorage.getItem('lkjhgfdsa'),
        };
      },
      openBooking(publicId) {
        this.$router.push({
          name: 'Booking',
          params: {
            booking_id: publicId,
          },
        });
      },
      openGateEntryDialog() {
        this.unticketed_alert_dialog = true;
        this.unticketed_details = this.getDefaultUnticketedDetails();
        const currentGate = this.getCurrentGate();
        if (currentGate && currentGate.gate_public_id === '05e7ee16') {
          this.unticketed_details.unticketed_gate = '05e7ee16';
        }
      },
      postGateEntryNote() {
        this.$store.dispatch('post_ranger_note', this.gateEntryNote);
        this.gateEntryDialog = false;
        this.gateEntryNote = {
          booking_id: 'new',
          note: '',
          show_on_invoice: false,
          ranger_note: 1,
          alert: false,
        };
      },
      postAlert() {
        // Validate required fields
        if (!this.unticketed_details.unticketed_destination) {
          this.$toast.error('Please select a destination');
          return;
        }
        if (!this.unticketed_details.unticketed_vehicle_registration) {
          this.$toast.error('Please enter vehicle registration');
          return;
        }
        
        // Prepare data matching backend expectations
        const postData = {
          unticketed_destination: this.unticketed_details.unticketed_destination,
          unticketed_adults: parseInt(this.unticketed_details.unticketed_adults) || 0,
          unticketed_children: parseInt(this.unticketed_details.unticketed_children) || 0,
          unticketed_vehicle_registration: this.unticketed_details.unticketed_vehicle_registration,
          session_id: localStorage.getItem('lkjhgfdsa'),
          driver: this.unticketed_details.unticketed_driver || '',
          mileage: this.unticketed_details.unticketed_mileage || '',
          gate: this.unticketed_details.unticketed_gate,
          infants: parseInt(this.unticketed_details.unticketed_infants) || 0,
          guide: parseInt(this.unticketed_details.unticketed_guide) || 0,
          name: this.unticketed_details.unticketed_name || '',
          vehicle_type: this.unticketed_details.unticketed_vehicle_type,
          alert: true
        };
        
        
        // Close dialog
        this.unticketed_alert_dialog = false;
        
        // Dispatch to Vuex store
        this.$store.dispatch('post_unticketed_alert', postData)
          .then(() => {
            this.$toast.success('Gate entry added successfully');
            // Reset form
            this.unticketed_details = this.getDefaultUnticketedDetails();
            this.isConservancyVehicle = false;
            // Refresh the alerts list
            this.$store.dispatch('get_unticketed_alert');
          })
          .catch((error) => {
  
            this.$toast.error('Failed to add gate entry');
          });
      },
      formated_date(date) {
        return new Date(date).toLocaleDateString();
      },
      loadVehicleTypes() {
        if (this.allVehiclesFees && this.allVehiclesFees.length) {
          this.vehicleTypes = this.allVehiclesFees.map((fee) => ({
            vehicle_charge_public_id: fee.vehicle_charge_public_id,
            vehicle_charge_category: fee.vehicle_charge_category,
          }));
        }
      },
      getCurrentGate() {
        return { gate_public_id: '05e7ee16' };
      },
    },
    created() {
      if (this.lmenu && this.lmenu.user_type_id === '35fcfdaf') {
        this.$store.dispatch('get_partner_checkin_today_bookings', this.lmenu.instiution_id);
        this.$store.dispatch('get_partner_checkout_today_bookings', this.lmenu.instiution_id);
      }

      this.$store.dispatch('get_all_destinations').then(() => {
        this.allDestinations = this.$store.state.DestinationStore.all_destinations || [];
      }).catch((error) => {
      });
      this.$store.dispatch('get_all_vehicle_fees');
      this.$store.dispatch('get_all_drivers');
      this.$store.dispatch('get_all_autos');

      this.$store.dispatch('get_all_gates').then(() => {
        this.allGates = this.$store.state.GateStore.all_gates || [];
        const currentGate = this.getCurrentGate();
        if (currentGate && currentGate.gate_public_id === '05e7ee16') {
          this.unticketed_details.unticketed_gate = '05e7ee16';
        }
      }).catch((error) => {
      });
    },
    beforeDestroy() {
      // Clean up any remaining intervals if they exist
    },
    watch: {
      '$store.state.VehicleFeeStore.all_vehicle_fees': {
        handler(newVal) {
          this.allVehiclesFees = newVal || [];
          this.loadVehicleTypes();
        },
        immediate: true,
      },
    },
  };
</script>

<style scoped>
  /* Futuristic Card */
  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

  .futuristic-card:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  }

  /* Tabs */
  .futuristic-tabs {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    border-radius: 8px;
    text-transform: uppercase;
  }

  .futuristic-tab {
    text-transform: none;
    font-weight: 600;
    color: #587e27;
    transition: all 0.3s ease;
  }

  .futuristic-tab:hover {
    background: rgba(46, 125, 50, 0.1);
  }

  /* Card Header */
  .card-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
    border-radius: 8px;
  }

  .earth-color {
    color: #587e27;
    font-weight: 600;
    margin: 0;
    font-size: 1.5rem;
  }

  .futuristic-title {
    position: relative;
    display: inline-block;
  }

  .futuristic-title::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, #587e27, transparent);
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.3s ease;
  }

  .futuristic-title:hover::after {
    transform: scaleX(1);
    transform-origin: left;
  }

  .title-decoration {
    height: 4px;
    background: linear-gradient(90deg, #587e27, transparent);
    margin-bottom: 16px;
    width: 100px;
  }

  /* Input Fields */
  .futuristic-search .v-input__slot,
  .futuristic-text-field .v-input__slot,
  .futuristic-select .v-input__slot,
  .futuristic-autocomplete .v-input__slot {
    border-radius: 8px;
    background: #f5f7fa;
    border: 1px solid rgba(46, 125, 50, 0.2);
    transition: all 0.3s ease;
  }

  .futuristic-search .v-input__slot:hover,
  .futuristic-text-field .v-input__slot:hover,
  .futuristic-select .v-input__slot:hover,
  .futuristic-autocomplete .v-input__slot:hover {
    border-color: #587e27;
    box-shadow: 0 0 10px rgba(46, 125, 50, 0.2);
  }

  .futuristic-search .v-input__slot:focus-within,
  .futuristic-text-field .v-input__slot:focus-within,
  .futuristic-select .v-input__slot:focus-within,
  .futuristic-autocomplete .v-input__slot:focus-within {
    border-color: #587e27;
    box-shadow: 0 0 15px rgba(46, 125, 50, 0.3);
  }

  /* Buttons */
  .futuristic-btn {
    border-radius: 8px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    margin: 8px;
  }

  .futuristic-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .futuristic-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.7s ease;
  }

  .futuristic-btn:hover::before {
    left: 100%;
  }

  .action-btn {
    background: linear-gradient(135deg, #587e27 0%, #587e27 100%) !important;
    color: white !important;
  }

  .submit-btn {
    background: linear-gradient(135deg, #587e27 0%, #4caf50 100%) !important;
  }

  /* Data Table */
  .futuristic-table {
    border-radius: 8px;
    background: #ffffff;
  }

  .futuristic-table th {
    color: #587e27;
    font-weight: 600;
    background: linear-gradient(45deg, #e8f5e9 0%, #f1f8e9 100%) !important;
    font-size: 0.9rem;
    padding: 16px 8px;
    border-bottom: 2px solid #587e27;
  }

  .futuristic-table tr:hover {
    background: rgba(232, 245, 233, 0.3) !important;
  }

  .futuristic-cell {
    padding: 12px 8px;
    border-bottom: 1px solid rgba(46, 125, 50, 0.1);
    transition: background-color 0.2s ease;
  }

  .futuristic-cell:hover {
    background: rgba(232, 245, 233, 0.2);
  }

  .action-taken-yes {
    color: #587e27;
    font-weight: 600;
  }

  .action-taken-no {
    color: #f44336;
    font-weight: 600;
  }

  /* Progress Bar */
  .futuristic-progress {
    height: 3px !important;
    border-radius: 3px;
  }

  /* Alerts */
  .futuristic-alert {
    border-radius: 8px;
    background: #fff5f5;
    border: 1px solid rgba(244, 67, 54, 0.2);
  }

  /* Dialog */
  .futuristic-dialog .v-dialog {
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }

  .dialog-card {
    background: #ffffff;
  }

  .dialog-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
  }

  .dialog-title {
    font-size: 1.5rem;
  }

  .dialog-content {
    padding: 16px;
  }

  .form-container {
    padding: 0;
  }

  .row-inputs {
    display: flex;
    gap: 16px;
  }

  .row-field {
    flex: 1;
  }

  .number-inputs {
    display: flex;
    gap: 16px;
  }

  .number-field {
    flex: 1;
  }

  .form-field {
    margin-bottom: 16px;
  }

  .dialog-actions {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }

  /* Button Group */
  .button-group {
    display: flex;
    gap: 16px;
    margin: 16px 0;
    justify-content: center;
  }

  /* Switch Section */
  .switch-section {
    margin: 16px 0;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid rgba(88, 126, 39, 0.2);
  }

  .futuristic-switch {
    margin: 0;
  }

  .switch-label {
    font-weight: 600;
    color: #587e27;
  }

  .vehicle-note {
    margin-top: 8px;
  }

  .info-alert {
    background: #e8f5e9;
    border-color: #587e27;
    color: #2e7d32;
  }

  .warning-alert {
    background: #fff3e0;
    border-color: #ff9800;
    color: #ef6c00;
  }

  /* Driver Section */
  .driver-section {
    margin-top: 16px;
    padding: 16px;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px solid rgba(88, 126, 39, 0.2);
  }

  /* Responsive Adjustments */
  @media (max-width: 960px) {
    .card-header {
      padding: 12px;
    }

    .earth-color {
      font-size: 1.25rem;
    }

    .futuristic-title::after {
      bottom: -3px;
    }

    .title-decoration {
      width: 80px;
      height: 3px;
    }

    .futuristic-search .v-input__slot,
    .futuristic-text-field .v-input__slot,
    .futuristic-select .v-input__slot,
    .futuristic-autocomplete .v-input__slot {
      margin-bottom: 12px;
    }

    .futuristic-btn {
      margin: 6px;
      font-size: 0.9rem;
    }

    .button-group {
      flex-direction: column;
      gap: 8px;
    }

    .futuristic-table th {
      padding: 12px 6px;
      font-size: 0.8rem;
    }

    .futuristic-cell {
      padding: 10px 6px;
    }

    .row-inputs,
    .number-inputs {
      flex-direction: column;
      gap: 12px;
    }

    .switch-section {
      padding: 8px;
    }
    
    .driver-section {
      padding: 12px;
    }
  }

  @media (max-width: 600px) {
    .card-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 8px;
    }

    .futuristic-search,
    .futuristic-text-field,
    .futuristic-select,
    .futuristic-autocomplete {
      width: 100%;
      margin-top: 12px;
    }

    .earth-color {
      font-size: 1.1rem;
    }

    .title-decoration {
      width: 60px;
      height: 2px;
    }

    .futuristic-btn {
      width: 100%;
      margin: 4px 0;
      font-size: 0.85rem;
    }

    .button-group {
      flex-direction: column;
      align-items: center;
    }

    .futuristic-table {
      font-size: 0.85rem;
    }

    .futuristic-table th {
      padding: 8px 4px;
      font-size: 0.75rem;
    }

    .futuristic-cell {
      padding: 8px 4px;
    }

    .action-btn {
      width: 100%;
    }

    .switch-section {
      margin: 12px 0;
      padding: 8px;
    }

    .driver-section {
      margin-top: 12px;
      padding: 8px;
    }
  }
</style>
